import { UserRole } from '../auth/types';

export const FILTER_EMPTY_VALUE = 'ALL';
export const INVALID_URL_MESSAGE = 'Поле повинно відповідати формату URL адреси. Наприклад: "https://www.rada.gov.ua/"';
export const FORMAT_DATE_STRING = 'yyyy-MM-dd';

export enum Gender {
    FEMALE = 'FEMALE',
    MALE = 'MALE',
    OTHER = 'OTHER'
}

export enum SUBJECT_TYPE {
    NORMAL = 'NORMAL',
    PSYCHOLOGY = 'PSYCHOLOGY',
    SPECIAL = 'SPECIAL',
    FOREIGN = 'FOREIGN'
}

export enum CONSULTATION_TYPE {
    WITH_PUPILS = 'WITH_PUPILS',
    WITH_REPRESENTATIVES = 'WITH_REPRESENTATIVES',
    WITH_EMPLOYEES = 'WITH_EMPLOYEES'
}

export const ConsultationType: { [key in CONSULTATION_TYPE]: string } = {
    [CONSULTATION_TYPE.WITH_PUPILS]: 'Консультація з учнями',
    [CONSULTATION_TYPE.WITH_REPRESENTATIVES]: 'Консультація з законними представниками дитини',
    [CONSULTATION_TYPE.WITH_EMPLOYEES]: 'Консультація з педагогічними працівниками'
};

export const UserRoleLabel: { [key in UserRole]: string } = {
    [UserRole.SYSTEM_ADMIN]: 'Системний адміністратор',
    [UserRole.SECRETARIAT]: 'Секретаріат',
    [UserRole.ADMIN]: 'Завідувач',
    [UserRole.PSYCHOLOGIST]: 'Практичний психолог',
    [UserRole.PRESCHOOL_TEACHER]: 'Вихователь',
    [UserRole.ASSISTANT_PRESCHOOL_TEACHER]: 'Асистент вихователя',
    [UserRole.JUNIORS_TEACHER]: 'Вчитель початкових класів',
    [UserRole.ASSISTANT_JUNIORS_TEACHER]: 'Асистент вчителя',
    [UserRole.TEACHER]: 'Вчитель-предметник',
    [UserRole.PARENT]: 'Представник дитини',
    [UserRole.SPEECH_THERAPIST]: 'Логопед',
    [UserRole.INTELLECTUAL_DISABILITY_TEACHER]: 'Олігофренопедагог',
    [UserRole.VISION_TEACHER]: 'Тифлопедагог',
    [UserRole.DEAF_TEACHER]: 'Сурдопедагог',
    [UserRole.METHODOLOGIST]: 'Методист',
    [UserRole.TEACHER_PPP]: 'Фахівець ППП',
    [UserRole.SPECIAL_EDUCATION_TEACHER]: 'Вчитель спеціальної освіти',
    [UserRole.FOREIGN_LANGUAGE_TEACHER]: 'Вчитель іноземної мови'
};

export const BooleanStringMapping: { [key: string]: boolean } = {
    true: true,
    false: false
};

export const YesNoChoices = [
    { id: 'yes', value: true, name: 'Так' },
    { id: 'no', value: false, name: 'Ні' }
];

export enum STATUS {
    ALL = 'ALL',
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    SUSPENDED = 'SUSPENDED'
}

export const StatusLabel = {
    [STATUS.ALL]: 'Усі',
    [STATUS.ACTIVE]: 'Активний',
    [STATUS.INACTIVE]: 'Неактивний',
    [STATUS.SUSPENDED]: 'Відсторонений'
};

export enum EmployeeTab {
    GENERAL = 'GENERAL',
    SCHEDULE = 'SCHEDULE',
    REPORTS = 'REPORTS'
}

export enum StaffRate {
    RATE_1 = 'RATE_1',
    RATE_0_75 = 'RATE_0_75',
    RATE_0_5 = 'RATE_0_5'
}

export const convertStaffRate = (staffRate: string | number): StaffRate => {
    switch (staffRate) {
        case 'RATE_1':
        case 1:
            return StaffRate.RATE_1;
        case 'RATE_0_75':
        case 0.75:
            return StaffRate.RATE_0_75;
        case 'RATE_0_5':
        case 0.5:
            return StaffRate.RATE_0_5;
        default:
            return StaffRate.RATE_1; // Default to RATE_1 if not specified
    }
};

export const StaffRateLabel: { [key in StaffRate]: string } = {
    RATE_1: '1,0 ставки',
    RATE_0_75: '0,75 ставки',
    RATE_0_5: '0,5 ставки'
};

export const StaffRateHours = {
    [StaffRate.RATE_1]: 40,
    [StaffRate.RATE_0_75]: 30,
    [StaffRate.RATE_0_5]: 20
};

export enum PassportType {
    ID_CARD = 'ID_CARD',
    OLD_PASSPORT = 'OLD_PASSPORT'
}

export const PassportLabel: { [key in PassportType]: string } = {
    ID_CARD: 'ID-картка',
    OLD_PASSPORT: 'Паспорт старого зразка'
};
export enum CalendarView {
    DAY = 'day',
    WEEK = 'week',
    MONTH = 'month',
    AGENDA = 'agenda'
}

export const CalendarViewList = [
    { id: CalendarView.DAY, name: 'День' },
    { id: CalendarView.WEEK, name: 'Тиждень' },
    { id: CalendarView.MONTH, name: 'Місяць' }
];

export enum DaysOfWeek {
    MONDAY = 'monday',
    TUESDAY = 'tuesday',
    WEDNESDAY = 'wednesday',
    THURSDAY = 'thursday',
    FRIDAY = 'friday',
    SATURDAY = 'saturday',
    SUNDAY = 'sunday'
}

export const DaysOfWeekLabel: { [key in DaysOfWeek]: string } = {
    [DaysOfWeek.MONDAY]: 'Понеділок',
    [DaysOfWeek.TUESDAY]: 'Вівторок',
    [DaysOfWeek.WEDNESDAY]: 'Середа',
    [DaysOfWeek.THURSDAY]: 'Четвер',
    [DaysOfWeek.FRIDAY]: "П'ятниця",
    [DaysOfWeek.SATURDAY]: 'Субота',
    [DaysOfWeek.SUNDAY]: 'Неділя'
};

export const SIZE_CONFIG = {
    'extra-small': { circle: '12px', fontSize: '5px' },
    small: { circle: '28px', fontSize: '12px' },
    medium: { circle: '42px', fontSize: '20px' },
    large: { circle: '64px', fontSize: '28px' },
    'extra-large': { circle: '110px', fontSize: '40px' }
};
